<tilby-dialog-toolbar mat-dialog-title
    title='DIGITAL_PAYMENTS.ZPMS_CONNECTOR.TITLE'
    [hideConfirm]="!selectedFolio"
    (confirm)="confirm()" />
@if(message) {
    <div class="tw-flex tw-justify-center tw-py-4" (click)="clearMessage()">
        <span>{{message | translate}}</span>
    </div>
}
@if(operationInProgress()) {
    <tilby-dialog-progress-bar />
}
<tilby-dialog-content>
    @if(loginForm) {
        <form [formGroup]="loginForm" (ngSubmit)="setupShop()" class="tw-flex tw-flex-col">
            <mat-form-field appearance="fill">
                <mat-label>{{'DIGITAL_PAYMENTS.ZPMS_CONNECTOR.CONNECTED_PMS' | translate}}</mat-label>
                <mat-select formControlName="connectedPms" required>
                    @for(pms of supportedPMS; track pms) {
                        <mat-option value="{{pms}}">{{pms}}</mat-option>
                    }
                </mat-select>
                @if(loginForm.get('type')?.hasError('required')) {
                    <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>{{'DIGITAL_PAYMENTS.ZPMS_CONNECTOR.ADDRESS' | translate}}</mat-label>
                <input matInput type="text" formControlName="address">
                @if(loginForm.get('address')?.hasError('required')) {
                    <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>{{'DIGITAL_PAYMENTS.ZPMS_CONNECTOR.USERNAME' | translate}}</mat-label>
                <input matInput type="text" formControlName="username">
                @if(loginForm.get('username')?.hasError('required')) {
                    <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>{{'DIGITAL_PAYMENTS.ZPMS_CONNECTOR.PASSWORD' | translate}}</mat-label>
                <input matInput type="password" formControlName="password">
                @if(loginForm.get('password')?.hasError('required')) {
                    <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>{{'DIGITAL_PAYMENTS.ZPMS_CONNECTOR.API_KEY' | translate}}</mat-label>
                <input matInput type="text" formControlName="apiKey">
                @if(loginForm.get('apiKey')?.hasError('required')) {
                    <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>{{'DIGITAL_PAYMENTS.ZPMS_CONNECTOR.PROPERTY_ID' | translate}}</mat-label>
                <input matInput type="text" formControlName="propertyId">
                @if(loginForm.get('propertyId')?.hasError('required')) {
                    <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            @if(showStagingFlag) {
                <mat-slide-toggle formControlName="stagingMode">{{'DIGITAL_PAYMENTS.ZPMS_CONNECTOR.STAGING' | translate}}</mat-slide-toggle>
            }
            <div class="tw-flex tw-justify-center">
                <button mat-raised-button color="primary" type="submit" [disabled]="!loginForm.valid">
                    {{'DIGITAL_PAYMENTS.ZPMS_CONNECTOR.SAVE_CREDENTIALS_ACTION' | translate}}
                </button>
            </div>
        </form>
    } @else if(foliosForm && folios) {
        <form [formGroup]="foliosForm" class="tw-flex tw-flex-col tw-p-4">
            <mat-form-field appearance="fill">
                <input matInput type="text" [formControl]="filterInput" placeholder="{{'DIGITAL_PAYMENTS.ZPMS_CONNECTOR.FILTER' | translate}}">
            </mat-form-field>
            <mat-tab-group animationDuration="0ms" class="tw-flex-grow">
                <mat-tab label="{{'DIGITAL_PAYMENTS.ZPMS_CONNECTOR.ROOM_FOLIOS' | translate}}">
                    @if(roomFolios) {
                        @if(roomFolios.length) {
                        <mat-selection-list #roomFolioList class="tw-mt-4 tw-max-h-[400px] tw-overflow-y-auto" [multiple]="false" (selectionChange)="onFolioSelect($event, 'room')">
                            @for(folio of visibleRoomFolios; track folio) {
                                <mat-list-option [disabled]="folio.noCharges == 'Y' || (!!folio.totalAmountTransferable?.amount && folio.totalAmountTransferable?.amount! < data.amount)" [value]="folio">
                                    <div class="tw-flex tw-flex-row tw-w-full">
                                        <mat-icon class="tw-m-auto tw-size-8 tw-text-2xl">meeting_room</mat-icon>
                                        <div class="tw-flex tw-flex-col tw-w-full tw-pr-4">
                                            <div class="tw-flex tw-items-center tw-space-x-2">
                                                @if(folio.guestNames?.[0]) {
                                                    <span class="tw-font-bold">{{folio.guestNames?.[0]?.firstName}} {{folio.guestNames?.[0]?.lastName}}</span>
                                                } @else if(folio.companyName) {
                                                    <span class="tw-font-bold">{{folio.companyName}}</span>
                                                } @else {
                                                    <span class="tw-font-bold">{{folio.folioId}}</span>
                                                }
                                            </div>
                                            <div class="tw-flex tw-justify-between tw-items-center tw-text-sm">
                                                @if(folio.checkIn) {
                                                    <span>{{folio.checkIn | date: 'dd/MM/yyyy'}}</span>
                                                }
                                                @if(folio.checkOut) {
                                                    <span>{{folio.checkOut | date: 'dd/MM/yyyy'}}</span>
                                                }
                                                @if(folio.totalAmount != null) {
                                                    <span>{{folio.totalAmount | tilbyCurrency}}</span>
                                                }
                                            </div>
                                        </div>
                                        @if(folio.keyDoorCode) {
                                        <span class="tw-flex tw-items-center tw-text-2xl tw-font-bold">{{folio.keyDoorCode}}</span>
                                        }
                                    </div>
                                </mat-list-option>
                                <mat-divider />
                            }
                            </mat-selection-list>
                        } @else {
                            <div class="tw-flex tw-justify-center tw-items-center tw-p-4 tw-text-gray-500">
                                {{'CASHREGISTER.PMS_COMMON.NO_ACCOUNT_AVAILABLE' | translate}}
                            </div>
                        }
                    }
                </mat-tab>
                @if(miscSalesFolios) {
                    <mat-tab label="{{'DIGITAL_PAYMENTS.ZPMS_CONNECTOR.MISC_SALES_FOLIOS' | translate}}">
                        @if(miscSalesFolios.length) {
                            <mat-selection-list #miscFolioList class="tw-mt-4 tw-max-h-[400px] tw-overflow-y-auto" [multiple]="false" (selectionChange)="onFolioSelect($event, 'misc')">
                                @for(folio of visibleMiscSalesFolios; track folio) {
                                    <mat-list-option [disabled]="folio.noCharges == 'Y' || (!!folio.totalAmountTransferable?.amount && folio.totalAmountTransferable?.amount! < data.amount)" [value]="folio">
                                        <div class="tw-flex tw-flex-row tw-w-full">
                                            <mat-icon class="tw-m-auto tw-size-8 tw-text-2xl">directions_walk</mat-icon>
                                            <div class="tw-flex tw-flex-col tw-w-full tw-pr-4">
                                                <div class="tw-flex tw-items-center tw-space-x-2">
                                                    @if(folio.guestNames?.[0]) {
                                                        <span class="tw-font-bold">{{folio.guestNames?.[0]?.firstName}} {{folio.guestNames?.[0]?.lastName}}</span>
                                                    } @else if(folio.companyName) {
                                                        <span class="tw-font-bold">{{folio.companyName}}</span>
                                                    } @else {
                                                        <span class="tw-font-bold">{{folio.folioId}}</span>
                                                    }
                                                </div>
                                                <div class="tw-flex tw-justify-between tw-items-center tw-text-sm">
                                                    @if(folio.totalAmount != null) {
                                                        <span>{{folio.totalAmount | tilbyCurrency}}</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </mat-list-option>
                                    <mat-divider />
                                }
                            </mat-selection-list>
                        } @else {
                            <div class="tw-flex tw-justify-center tw-items-center tw-p-4 tw-text-gray-500">
                                {{'CASHREGISTER.PMS_COMMON.NO_ACCOUNT_AVAILABLE' | translate}}
                            </div>
                        }
                    </mat-tab>
                }
            </mat-tab-group>
        </form>
    }
</tilby-dialog-content>